var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcBalckWebsite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 41440566"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 288",
    cx: 9.99935,
    cy: 10,
    r: 7.33333,
    stroke: "#363A44",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M10 2.5V17.5",
    stroke: "#363A44",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M17.5 10L2.5 10",
    stroke: "#363A44",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 24",
    d: "M9.99877 2.5C5.02558 6.60293 4.51742 12.859 9.99877 17.5",
    stroke: "#363A44",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M9.99927 2.5C14.9725 6.60293 15.4806 12.859 9.99927 17.5",
    stroke: "#363A44",
    strokeWidth: 1.5
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcBalckWebsite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_balck_website.85b289a6eff9b5e8d4bd29fc60b27ee2.svg";